 import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { apiGet } from '../../axiosConfig';
import { IApiDataResponse } from '../../dto/API.dto';
import { IVisibleStation } from '../../dto/StationVisibility.dto';

const getVisibleStations = (companyId: number) => {
  return apiGet(`/v1/company/${companyId}/stations/visible`).then(
    (response: AxiosResponse<IApiDataResponse<IVisibleStation[]>>) => {
      return response.data.data;
    },
  );
};

export const useRqVisibleStations = (companyId: number) => {
  return useQuery<IVisibleStation[]>({
    queryKey: ['api/v1/company', companyId, 'stations', 'visible'],
    queryFn: () => getVisibleStations(companyId),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!companyId,
  });
};
